export default {
  LOAD_SUBCOMPETENCY_FORM_PAGE_START: 'LoadSubcompetencyFormPageStart',
  LOAD_SUBCOMPETENCY_FORM_PAGE_END: 'LoadSubcompetencyFormPageEnd',
  LOAD_SUBCOMPETENCY_GROUPS_START: 'LoadSubcompetencyGroupsStart',
  LOAD_SUBCOMPETENCY_GROUPS_END: 'LoadSubcompetencyGrouopsEnd',
  LOAD_STUDY_PROGRAMS_START: 'LoadStudyProgramsStart',
  LOAD_STUDY_PROGRAMS_END: 'LoadStudyProgramsEnd'
};